import React, { useState, useEffect, useContext } from "react";
import {
    Box,
    Button,
    CssBaseline
} from "@mui/material";
import { Navigate } from 'react-router-dom';
import Header from "../components/landingPageComponents/Header";
import { Banner } from "../components/landingPageComponents/Banner";

import CompetitionsData from "../data/competitionsData.json";
import landingPageJson from "../data/competitionsPageData.json";
import JsonData from "../data/competitionsPageData.json";

import { getCurrentUser } from '../components/Helper';
import Overview from "../components/landingPageComponents/Overview";
import Footer from "../components/landingPageComponents/Footer";
import CompetitionOverview from "../components/landingPageComponents/CompetitionOverview";
import WinnersCards from "../components/landingPageComponents/WinnersCards";
import Testimonials from "../components/landingPageComponents/Testimonials";
import { AuthContext } from "../components/Auth/Auth";

const LandingPage = () => {
    const [competitionsData, setCompetitionsData] = useState([]);
    const [landingPageData, setLandingPageData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    // const currentUser = getCurrentUser();
    const { currentUser } = useContext(AuthContext);

    useEffect(() => {
        const loadData = async () => {
            try {
                setLandingPageData(JsonData);
                setCompetitionsData(CompetitionsData);
            } catch (error) {
                console.error('Error loading landing page data:', error);
            } finally {
                setIsLoading(false);
            }
        };
        loadData();
    }, []);

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (currentUser) {
        return <Navigate to="/clubs" replace />;
    }

    return (
        <div>
            <CssBaseline />
            <Header />
            <Banner data={landingPageData.Header} />
            <Box sx={{ mt: 6, px: { xs: 4, s: 8, md: 10, lg: 25 } }}>
                <Overview overview={landingPageJson?.overview} />
                <Box sx={{ mt: 4 }}>
                    <img
                        src={"../img/collage.png"}
                        alt={"RoundPier Collage"}
                        style={{ maxWidth: "100%", height: "auto", borderRadius: "10px" }}
                    />
                </Box>
                <Button
                    style={{
                        display: "block",
                        margin: "20px auto",
                        padding: "15px 30px",
                        fontSize: "18px",
                        textAlign: "center",
                    }}
                    href="https://www.roundpier.com/competitions"
                >
                    Check Our Past Competitions
                </Button>
                <Box sx={{ mt: 6, mb: 6 }}>
                    <Testimonials testimonials={landingPageJson?.testimonials} />
                </Box>
            </Box>
            <Footer footer={landingPageJson?.footer} />
        </div>
    );
};

export default LandingPage;
